import { Link } from "react-router-dom";
import { ArrowLeftRight } from "lucide-react";

export default function ComparePill({ to, label }) {
  return (
    <Link
      to={to}
      data-testid="compare-pill"
      className="fixed bottom-6 left-6 z-50 flex items-center gap-2 border border-slate-400/60 bg-white/90 px-4 py-2.5 font-mono text-[11px] tracking-[0.2em] text-slate-600 shadow-lg backdrop-blur transition-transform duration-200 hover:-translate-y-0.5"
    >
      <ArrowLeftRight className="h-3.5 w-3.5" aria-hidden="true" />
      {label}
    </Link>
  );
}
